import React, { useState } from "react";
import { Alert, Card, CardBody, Col, Modal, Placeholder, Row } from "react-bootstrap";
import ButtonComponent from "../../../../components/ButtonComponent";
import "./index.css";
import { useSelector } from "react-redux";
import { useGetSalesWalletByRestaurantIdQuery } from "../../../../redux/services/restaurantServices";

const RestaurantWallet = () => {
  const RestID = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id
  );

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, error, isLoading } =
    useGetSalesWalletByRestaurantIdQuery(RestID);

  // Loading state
  if (isLoading) {
    return <div><>
      <div className='d-flex justify-content-center'>
        <Placeholder animation="glow">
          <Placeholder xs={6} />
        </Placeholder></div>
      <Card className="carts-view-wallet-upper-cards-left-card">
        <CardBody>
          <Row>
            <Col lg={3}>
              <Card className="carts-view-wallet-first-card p-5">
                <CardBody>
                  <Placeholder animation="glow">
                    <Placeholder xs={6} />
                    <Placeholder xs={6} />
                  </Placeholder>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card className='carts-view-wallet-second-card p-5'>
                <CardBody>
                  <Placeholder animation="glow">
                    <Placeholder xs={6} />
                    <Placeholder xs={6} />
                  </Placeholder>
                </CardBody>
              </Card>
            </Col>
            <Col lg={6}>
              <Card className='carts-view-wallet-second-card p-5'>
                <CardBody>
                  <Placeholder animation="glow">
                    <Placeholder xs={6} />
                    <Placeholder xs={6} />
                  </Placeholder>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card></></div>;
  }

  // Error state
  if (error) {
    return <div><Alert>Error fetching sales wallet details.</Alert></div>;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const availableBalance =
    (data?.cashSales ?? 0) +
    (data?.creditCardSales ?? 0) -
    (data?.commissionsToCart ?? 0);

  const creditLimit =
    (data?.creditCardSales ?? 0) - (data?.payableToPlatform ?? 0);

  return (
    <div className="wallet-body">
      <div className="wallet-upper">
        {/* Left Card with Three Boxes */}
        <Card className="wallet-summary-card">
          <CardBody className="wallet-summary-content">
            <div className="wallet-small-cards-wrapper">
              <div className="wallet-small-card available-balance-card">
                <h6>Available Balance</h6>
                <h4>
                  {" "}
                  {data?.currency ?? ""} {availableBalance ?? "N/A"}
                </h4>
              </div>
              <div className="wallet-small-card">
                <h6>Credit Limit</h6>
                <h4>
                  {" "}
                  {data?.currency ?? ""} {creditLimit ?? "N/A"}
                </h4>
              </div>
              {/* <div className="wallet-small-card">
                <div
                  className="wallet-top-up-content"
                  onClick={handleOpenModal}
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon icon={faArrowUpFromBracket} />
                  <h5>Top Up</h5>
                </div>
              </div> */}
            </div>

            {/* Progress Bar */}
            <div className="progress-bar-wrapper">
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: "40%" }}></div>
              </div>
            </div>
          </CardBody>
        </Card>

        {/* Right Card for Details */}
        <Card className="wallet-details-card">
          <CardBody>
            <Row className="details-row">
              <Col className="text-left">Cash Sales</Col>
              <Col className="text-right">
                {data?.currency ?? ""} {data?.cashSales ?? "N/A"}
              </Col>
            </Row>
            <Row className="details-row">
              <Col className="text-left">Credit & Sales</Col>
              <Col className="text-right">
                {data?.currency ?? ""} {data?.creditCardSales ?? "N/A"}
              </Col>
            </Row>
            <Row className="details-row">
              <Col className="text-left">Your Earnings</Col>
              <Col className="text-right">
                {data?.currency ?? ""} {data?.myEarnings ?? "N/A"}
              </Col>
            </Row>
            <Row className="details-row">
              <Col className="text-left">Commissions to Cart</Col>
              <Col className="text-right">
                {data?.currency ?? ""} {data?.commissionsToCart ?? "N/A"}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>

      {/* Modal */}
      <Modal show={isModalOpen} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Money</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <label className="form-label">Amount:</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter amount"
              />
            </div>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <label className="form-label">Wallet Name:</label>
              <input
                type="text"
                className="form-control"
                value="Cart Wallet"
                readOnly
              />
            </div>
            <div className="d-flex align-items-center gap-2 mb-3">
              <label className="form-label">Remarks:</label>
              <input
                type="text"
                className="form-control"
                placeholder="Optional"
              />
            </div>
            <div className="d-flex align-items-center gap-2 mb-3">
              <label className="form-label">Add Account:</label>
              <select className="form-select">
                <option>My Commercial XXXX XXXX 36</option>
              </select>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="d-flex align-items-center justify-content-center">
          <ButtonComponent titel="Confirm" type="submit" />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RestaurantWallet;
